module.exports = __webpack_public_path__ + "static/media/share.faca3dc4.svg";